class ProductCardSlider extends BaseSlider {
  constructor() {
    super();

    this.swiperInstance = null;
    this.handleResize = this.handleResize.bind(this);
    this.isMobile = window.innerWidth < 1023;
  }

  connectedCallback() {
    this.toggleSwiper();

    this.observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.handleResize(entry.contentRect);
      }
    });

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
        this.observer.disconnect(); 
    }
  }  

  handleResize() {
    const isNowMobile = window.innerWidth < 1023;

    if (isNowMobile !== this.isMobile) {
      this.isMobile = isNowMobile;
      this.toggleSwiper();
    }
  }

  toggleSwiper() {
    if (this.isMobile) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  initSwiper() {
    if (!this.swiperInstance) {
      this.swiperInstance = new Swiper(this, {
        slidesPerView: 1,
        loop: true,
        preventInteractionOnTransition: true,
        nested: !!this.closest('.swiper'),
      });
    }
  }
}

customElements.define('product-card-slider-controller', ProductCardSlider);
